export const gaplessDrainMs = 15_000;
export const maxRetries = 100;
/**
 * Consecutive fetch-level connection failures — the SSE request never produced
 * an HTTP response (DNS failure, TLS error, CORS block, connection refused) —
 * after which a host should stop waiting on DUST. Unlike a 503 or a DDR, these
 * prove nothing on the path to DUST is answering at all, and in practice do not
 * recover on their own. See dustUnreachableLatch.
 */
export const consecutiveFetchFailureLimit = 10;
/**
 * How long a tab honors its own "DUST is unreachable" verdict before trying DUST
 * again. Long enough that a tab left open through a real outage is not
 * repeatedly dragged back onto a dead transport, short enough that a network
 * path since fixed by IT does not strand a long-lived tab on Pusher forever.
 * Re-latching after a failed retry costs one fetch failure rather than a fresh
 * streak, because the engine keeps counting throughout.
 */
export const dustUnreachableTtlMs = 7 * 24 * 60 * 60 * 1_000;
export const defaultHeartbeatTimeoutMs = 45_000;
export const heartbeatCheckIntervalMs = 5_000;
/**
 * Seconds before `config.expiration` at which we treat the auth token as
 * already expired and request a fresh config rather than trying to use it.
 * The buffer covers clock skew + the round-trip cost of refreshing.
 */
export const configRefreshLeadSeconds = 30;
/**
 * Byte cap for the connection-diagnostics log ring buffer (DustLogBuffer). The
 * cap counts each entry's serialized line (ISO timestamp + space + message), so
 * the surfaced `recentLogs` array stays under ~8KB in Sentry `extra.dust`.
 */
export const maxDustLogBufferBytes = 8_192;
/**
 * A tab that has not finished connecting in this long after load is treated as failing to
 * connect. Earlier than this, being on Pusher is the normal page-load race, not a fallback.
 */
export const realtimeFallbackPageLoadGraceMs = 30_000;
